export default {
  /** Метро */
  UNDERGROUND: 'underground',
  /** Район */
  DISTRICT: 'district',
  /** Шоссе */
  HIGHWAY: 'highway',
  /** ЖК */
  NEWOBJECT: 'newobject',
  /** Застройщик */
  BUILDER: 'builder',
  /** Населённый пункт: город/деревня/село */
  LOCATION: 'location',
  /** Улица */
  STREET: 'street',
  /** Дом */
  HOUSE: 'house',
  /** Многоугольная область на карте */
  POLYGON: 'polygon',
  /** Круглая область на карте (формат бэкенда) */
  DISTANCE: 'distance',
  /** Круглая область на карте (формат АПИ Яндекс.Карт) */
  CIRCLE: 'circle',
};


// WEBPACK FOOTER //
// ./src/serp/constants/geo-types.js